import React from 'react';
import { ApolloProvider } from '@apollo/client';
import Head from 'next/head';
import ScriptTags from '@/components/ScriptTags';
import { vodafoneFont } from '@/fonts';
import { fullScreenGridClasses } from '@/styles/grid';
import Analytics from '@/components/Analytics';
import { createApolloClient } from '@/clients/apollo';
import { contentfulAPIURL } from '@/clients/contentful';
import RadioPlayer from '@/components/Radio/RadioPlayer';
import { Poppins } from 'next/font/google';
import { useRouter } from 'next/router';

type Props = {
  children?: React.ReactNode;
};

const poppins = Poppins({
  subsets: ['latin'],
  weight: ['100', '300', '400', '500', '600', '700', '900'],
});

const RootLayout: React.FC<Props> = ({ children }) => {
  const router = useRouter();
  const apolloClient = createApolloClient(
    contentfulAPIURL(
      process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID || '',
      process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT || ''
    ),
    process.env.NEXT_PUBLIC_CONTENTFUL_CD_TOKEN || ''
  );

  // Evil hack for layerless views
  const isNoLayout = router.asPath.indexOf('/nolayout') === 0;

  return (
    <ApolloProvider client={apolloClient}>
      <Head>
        <meta httpEquiv="Content-type" content="text/html; charset=UTF-8" />
      </Head>
      {isNoLayout ? (
        <>{children}</>
      ) : (
        <>
          <ScriptTags />
          <main className={`${vodafoneFont.className} flex min-h-screen justify-center bg-white-15`}>
            <div className={`${fullScreenGridClasses} ${poppins} overflow-x-hidden`}>
              {children}
              <RadioPlayer />
            </div>
            <Analytics />
          </main>
        </>
      )}
    </ApolloProvider>
  );
};

export default RootLayout;
